export default __webpack_public_path__ + "images/5af5bc7708252c38d92196c28285e4c3-Eventbrite_NYE_HomepageB_1919x543.webp";